import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.001" width="1em" height="1em" {...props}><path d="M5.469.006c-.492 0-.798.216-1.033.457C4.2.703 4 1.02 4 1.493V2H2v14l12.002.002v-14h-2v-.398L12 1.576a1.625 1.625 0 00-.416-1.013c-.236-.28-.62-.588-1.201-.555l.054-.002zm.533 2.002L10 2.01v1.994h1.998v9.994H4.002V4.002h2z" style={{
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1,
      marker: "none"
    }} color="#bebebe" fontWeight={400} fontFamily="sans-serif" overflow="visible" fill="#2e3436" /></svg>;
}

export default SvgComponent;